import { IntrinsicSizeImg } from 'components/Img';
import Text from 'components/Text';
import type { AssetResponse } from 'models/asset';
import { is } from 'utils/helpers';

interface Props {
	heading?: string;
	images?: AssetResponse[];
	text?: string;
}

/** Warning symbols and text. */
export default function WarningSymbols({ heading, images, text }: Props) {
	return (
		<>
			{is.arrayWithLength(images) && (
				<div className="mb-4 flex flex-wrap gap-4">
					{images.map((image) => (
						<IntrinsicSizeImg
							key={image.src}
							asset={image}
							className="h-14 w-auto"
						/>
					))}
				</div>
			)}
			<Text as="h3" styleAs="p" className="mb-2 font-bold">
				{heading}
			</Text>
			<Text as="p">{text}</Text>
		</>
	);
}
WarningSymbols.displayName = 'WarningSymbols';
